export default __webpack_public_path__ + "static/media/use_action_back_xw.0b7172dd.png";